import './timePeriodSettingsSection.less';
import React, { FC } from 'react';
import { observer } from 'mobx-react';
import b_ from 'b_';

import { Section } from 'controls/react/layout/section';
import { Toolbar } from 'controls/react/layout/toolbar';
import { BoxView } from 'controls/react/layout/boxView';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { AntSwitch } from 'controls/react/ant/antSwitch';
import { AntCheckbox } from 'controls/react/ant/antCheckbox';
import { AntSelect } from 'controls/react/ant/antSelect';
import {
	TimePeriodAppearance,
	TimePeriodSelector,
	timePeriodToDisplayString,
} from 'controls/react/form/timePeriodSelector';
import { TimePeriodType } from 'controls/react/form/timePeriodType';
import { linkModel } from 'framework/mobx-integration';
import { i18n } from 'controls/designer/features/widgets/datasources/shared/translations';

import { TimePeriodSettingsSectionProps } from './types';

const b = b_.with('time-period-settings-section');

const TimePeriods = [
	TimePeriodType.Last24Hours,
	TimePeriodType.Last7Days,
	TimePeriodType.Last30Days,
	TimePeriodType.Custom,
	TimePeriodType.DynamicInterval,
	TimePeriodType.All,
	TimePeriodType.LastN,
];

export const TimePeriodSettingsSection: FC<TimePeriodSettingsSectionProps> = observer(({ store, model }) => {
	const timeColumns = store.timeColumns;
	const noTimeColumns = timeColumns?.loaded && timeColumns.options.length == 0;
	const timeSelectorDisabled = !!timeColumns && !model.timePeriodColumn;

	const content = () => {
		if (noTimeColumns) {
			return (
				<BoxView type={'info-2'}>
					{i18n('This datasource does not have a time column and cannot use the time selector')}
				</BoxView>
			);
		}

		if (!store.enableTimeSelector) {
			return (
				<BoxView type={'info-2'}>
					{i18n('When disabled, the default time period from the datasource will be applied')}{' '}
					{i18n(
						'The default for {0} is {1}',
						store.currentDataSource?.name,
						timePeriodToDisplayString(store.defaultTimeSelector),
					)}
				</BoxView>
			);
		}

		return (
			<>
				{timeColumns && (
					<FormEntryNew label={i18n('Time column')} model={model} modelField={'timePeriodColumn'}>
						<AntSelect options={timeColumns.options} />
					</FormEntryNew>
				)}
				<FormEntryNew model={model} modelField={'period'} className={b('time-selector')}>
					<TimePeriodSelector
						periods={TimePeriods}
						appearance={TimePeriodAppearance.Buttons}
						disabled={timeSelectorDisabled}
					/>
					<AntCheckbox {...linkModel(model, 'hideTimePeriodSelector')} disabled={timeSelectorDisabled}>
						{i18n('Hide time selector')}
					</AntCheckbox>
				</FormEntryNew>
			</>
		);
	};

	return (
		<Section appearance={'frame-top-only'}>
			<Toolbar title={i18n('Time')}>
				{!noTimeColumns && (
					<AntSwitch
						checkedChildren={i18n('Active')}
						unCheckedChildren={i18n('Inactive')}
						{...linkModel(store, 'enableTimeSelector')}
					/>
				)}
			</Toolbar>
			{content()}
		</Section>
	);
});
